import React from 'react'

export default class SubmissionActionsCell extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      submission: props.submission
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  render() {
    let { submission } = this.state
    return (
      <>
        <a
          href="javascript:;"
          class="btn btn-icon btn-light btn-hover-primary btn-sm"
          title="Edit"
          onClick={() => this.props.onEditPressed(submission) }
        >
          <i class="flaticon2-pen text-primary icon-sm"></i>
        </a>
      </>
    )
  }
}
